import type { LegalTerms, LegalTermsCategory } from "dutyon-server/types";
import { httpClient } from "./httpClient";

export const getAdminTerms = async (params?: {
  page?: number;
  limit?: number;
  categoryKey?: string;
}): Promise<{ list: LegalTerms[]; total: number }> => {
  const response = await httpClient.get<{ list: LegalTerms[]; total: number }>("/admin/terms", {
    params,
  });
  return response.data;
};

export const createAdminTerms = async (data: {
  categoryKey: string;
  version: string;
  title: string;
  content: string;
  isRequired: boolean;
  isActive: boolean;
}): Promise<LegalTerms> => {
  const response = await httpClient.post<LegalTerms>("/admin/terms", data);
  return response.data;
};

export const getAdminTermsDetail = async (id: string): Promise<LegalTerms> => {
  const response = await httpClient.get<LegalTerms>(`/admin/terms/${id}`);
  return response.data;
};

export const updateAdminTerms = async ({
  id,
  data,
}: {
  id: string;
  data: {
    title?: string;
    content?: string;
    isRequired?: boolean;
    isActive?: boolean;
  };
}): Promise<LegalTerms> => {
  const response = await httpClient.put<LegalTerms>(`/admin/terms/${id}`, data);
  return response.data;
};

export const deleteAdminTerms = async (id: string): Promise<{ id: string; message: string }> => {
  const response = await httpClient.delete<{ id: string; message: string }>(`/admin/terms/${id}`);
  return response.data;
};

export const getLatestTerms = async (): Promise<LegalTerms[]> => {
  const response = await httpClient.get<LegalTerms[]>("/terms/latest");
  if (!Array.isArray(response.data)) {
    throw new Error("최신 약관 API 응답 형식이 올바르지 않습니다.");
  }
  return response.data;
};

export const getAdminTermsCategories = async (): Promise<LegalTermsCategory[]> => {
  const response = await httpClient.get<LegalTermsCategory[]>("/admin/terms/categories");
  return response.data;
};

export const createAdminTermsCategory = async (data: {
  key: string;
  name: string;
  description?: string;
}): Promise<LegalTermsCategory> => {
  const response = await httpClient.post<LegalTermsCategory>("/admin/terms/categories", data);
  return response.data;
};
